import { render, staticRenderFns } from "./KYCCustomFieldList.vue?vue&type=template&id=57c6a7e8&scoped=true&lang=pug&"
import script from "./KYCCustomFieldList.vue?vue&type=script&lang=js&"
export * from "./KYCCustomFieldList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c6a7e8",
  null
  
)

/* custom blocks */
import block0 from "./KYCCustomFieldList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports